import { render, staticRenderFns } from "./NewIQCSeleItem.vue?vue&type=template&id=0d4f685e&scoped=true"
import script from "./NewIQCSeleItem.vue?vue&type=script&lang=js"
export * from "./NewIQCSeleItem.vue?vue&type=script&lang=js"
import style0 from "./NewIQCSeleItem.vue?vue&type=style&index=0&id=0d4f685e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f685e",
  null
  
)

export default component.exports